import { EventItem } from "../../types/api/event.type";
import { ReportItem } from "../../types/api/report.type";

const formatDate = (date: Date): string => date.toISOString().split("T")[0];

export const todayDateOnly = (): string => formatDate(new Date());

export const parseDate = (date: string | Date): string => formatDate(new Date(date));

export const isDateInRange = (target: string, start: string, end: string): boolean => target >= start && target <= end;

export const buildDateRange = (startDate: string, endDate: string): string[] => { 
    console.log(startDate, endDate);
     
    const start = new Date(startDate);
    const end = new Date(endDate);
    const out: string[] = [];
    const cursor = new Date(start);
    while (cursor <= end) {
        out.push(formatDate(cursor));
        cursor.setDate(cursor.getDate() + 1);
    }    
    return out;
};

export const subtractDays = (date: string, days: number): string => {
    const value = new Date(date);
    value.setDate(value.getDate() - days);
    return formatDate(value);
};

export const toEventItem = (item: Record<string, unknown>): EventItem => ({
    id: Number(item.id ?? item.event_id ?? 0),
    name: String(item.name ?? item.title ?? "Event"),
    start_date: parseDate(String(item.start_at)),
    end_date: parseDate(String(item.end_at)),
});

export const toReportItem = (item: Record<string, unknown>): ReportItem => ({
    id: Number(item.id),
    event_id: Number(item.event_id),
    report_type_id: Number(item.report_type_id),
    event_day: parseDate(String(item.event_day)),
    athlete_user_id: Number(item.athlete_user_id),
    status: item.status == "submitted" ? "submitted" : "draft",
});

export const isCurrentEvent = (event: EventItem, today: string): boolean => isDateInRange(today, event.start_date, event.end_date);

export const isPastEvent = (event: EventItem, today: string): boolean => event.end_date < today;

export const resolveOwnerId = (report: ReportItem): number => report.athlete_user_id;

export const findCompiledReport = (reports: ReportItem[], eventId: number, day: string, memberId?: number): ReportItem | undefined => {
    return reports.find((report) => {
        if (report.event_id !== eventId) return false;
        if (report.event_day !== day) return false;
        if (report.status !== "submitted") return false;
        if (memberId === undefined) return true;
        return resolveOwnerId(report) === memberId;
    });
};

export const findMemberReportForDay = (reports: ReportItem[], eventId: number, day: string, memberId: number): ReportItem | undefined => {
    return reports.find((report) => {
        console.log(report, eventId, day);
        
        if (report.event_id !== eventId) return false;
        if (report.event_day !== day) return false;
        return resolveOwnerId(report) === memberId;
    });
};

export const countPendingReportsForMember = (event: EventItem, reports: ReportItem[], memberId: number, today: string): number => {
    return buildDateRange(event.start_date, event.end_date)
        .filter((day) => day <= today)
        .filter((day) => !findCompiledReport(reports, event.id, day, memberId))
        .length;
};
